module.exports = {"short":"it","long":"Italian","createdBy":"nicolo-ribaudo"}


//////////////////
// WEBPACK FOOTER
// ./store/it/meta.json
// module id = htUn
// module chunks = 1